import { Container, Row } from 'reactstrap';

import Overview from './overview/Overview';
import Breadcrumbs from '../../coreComponents/breadcrumbs';
import { useTranslation } from 'react-i18next';

const DashboardContainer = () => {
  const {t} = useTranslation()
  return (
    <>
      <Breadcrumbs mainTitle={t('stats.overview')} />
      <Container fluid className="default-dashboard">
        <Row>
          <Overview />
        </Row>
      </Container>
    </>
  );
};

export default DashboardContainer;
